<template>
    <el-dialog :append-to-body="true" :close-on-click-modal="false" :style="{ 'left': left }" :visible.sync="collectionShow"
               class="collectionNewDialog"
               destroy-on-close>
        <div class="headerTitle">
            生成操作确认单
        </div>
        <div v-if="collectionShow" class="bodyContent">
            <p>确认项目及收费金额</p>
            <div>
                <div class="selectTags">
                    <div class="itemTitle">
                        <i class="el-icon-circle-plus iconOptions"></i>
                        <p style="margin-left: 10px">
                            <span style="font-size: 16px">价格</span>
                            <span style="margin-left: 5px;font-size: 12px;color: rgba(86,127,0,100)">单选</span>
                        </p>
                    </div>
                    <div class="right">
                        <el-radio-group v-model="checkboxItems" style="display: flex;flex-direction: column;margin-left: 20px;margin-top: 5px"
                                        @change="checkboxItemsChange">
                            <el-radio :label="1" style="margin-bottom: 10px">方案总价{{
                                    totalPayPrice ? "(" +
                                        totalPayPrice.toFixed(2) + '¥)' : ''
                                }}
                            </el-radio>
                            <el-radio :label="-1" style="margin-bottom: 10px">单人价格{{
                                    totalPayPrice ? "(" +
                                        (totalPayPrice / checkBudget.useNumber).toFixed(2) + '¥)' : ''
                                }}
                            </el-radio>
                            <el-radio :label="2" style="margin-bottom: 10px">
                                <span>项目总价</span>
                                <el-checkbox-group v-if="checkboxItems === 2 && stateTotalPayPrice.filter(x => x.price > 0).length"
                                                   v-model="projectCheckboxItems"
                                                   style="display: flex;flex-wrap: wrap;margin-left: 20px;background-color: white;padding: 5px;border-radius: 5px;margin-top: 5px"
                                                   @change="projectCheckboxItemsChange">
                                    <el-checkbox v-for="(itemCheck, itemCheckIndex) in stateTotalPayPrice.filter(x => x.price > 0)" :key="itemCheckIndex"
                                                 :label="itemCheck.state"
                                                 border
                                                 style="width: 180px;margin-left: 0;margin-bottom: 5px">
                                        {{ stockTypeMap[itemCheck.state].typeName }}（{{
                                            (itemCheck.price).toFixed(2)
                                        }}¥）
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-radio>
                            <el-radio :label="3" style="margin-bottom: 10px">
                                <span>按具体产品</span>
                                <span style="margin-left: 5px;font-size: 12px;color: rgba(86,127,0,100);font-weight: 400"
                                      @click="chooseProduct">选择产品</span>
                            </el-radio>
                            <el-radio :label="4" style="margin-bottom: 10px">
                                <span>自定义</span><span v-if="checkboxItems==4"
                                                         style="margin-left: 10px;font-size: 0.12rem;">必填</span>
                                <div v-if="checkboxItems === 4"
                                     style="background-color: white;padding: 5px;border-radius: 5px;margin-top: 5px;margin-left: 20px;width: 93%">
                                    <el-input v-model="selectRow.chargingContent" :rows="4" placeholder="请填写你的收款内容"
                                              type="textarea"></el-input>
                                </div>
                            </el-radio>
                        </el-radio-group>
                        <div style="margin-left: 20px">
                            <el-form>
                                <el-form-item label="收费金额">
                                    <el-input v-model="selectRow.feeAmount" :min="0" placeholder="请输入收费金额？" style="width: 370px"
                                              type="number"></el-input>
                                </el-form-item>
                                <el-form-item label="币种信息">
                                    <el-tooltip content="自定义的情况下才能选择币种！">
                                        <el-select v-model="selectRow.currency" :disabled="checkboxItems !== 4"
                                                   style="width: 370px" @change="currencyChange">
                                            <el-option v-for="(currency, index) in currencyList" :key="index"
                                                       :label="currency.currencyOption" :value="currency.code">
                                                <p style="display: flex">
                                                    <span style="width: 30px">{{ currency.code }}</span>
                                                    <span style="margin-left: 10px;width: 70px">{{
                                                            currency.name
                                                        }}</span>
                                                    <span style="margin-left: 40px;width: 70px">
                                                        今日收款汇率：
                                                        <span v-if="currency.payeeRate">{{ currency.payeeRate }}</span>
                                                        <span v-else>暂无信息</span>
                                                    </span>
                                                </p>
                                            </el-option>
                                        </el-select>
                                    </el-tooltip>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div
                            v-if="checkboxItems !== 4"
                            style="margin-left: 20px;background-color: white;padding: 10px;border-radius: 5px;width: 93%">
                            <el-radio-group v-model="selectRow.payOrder">
                                <el-radio :label="1" border>客人缴费后系统自动下采购订单</el-radio>
                                <el-radio :label="2" border>客人缴费后，我自己手动下产品采购订单</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <!--费用说明-->
                <div class="selectTags">
                    <div class="itemTitle">
                        <i class="el-icon-circle-plus iconOptions"></i>
                        <p style="margin-left: 10px">
                            <span style="font-size: 16px">费用说明</span>
                        </p>
                    </div>
                    <div class="right">
                        <el-form label-position="top" style="margin-left: 20px">
                            <el-form-item label="服务提供方">
                                <el-input v-model="selectRow.serviceProvider" placeholder="请填写服务提供方？"
                                          style="width: 96%"></el-input>
                                <!--                                <el-input  placeholder="请填写服务提供方？"-->
                                <!--                                          v-model="selectRow.serviceProvider"></el-input>-->
                            </el-form-item>
                            <el-form-item label="联系人">
                                <el-input v-model="selectRow.contacts" placeholder="请填写联系人？"
                                          style="width: 96%"></el-input>
                            </el-form-item>
                            <el-form-item label="发票说明">
                                <el-input v-model="selectRow.invoiceDescription" :rows="4" placeholder="请填写发票说明（非必填）？"
                                          style="width: 96%"
                                          type="textarea"></el-input>
                            </el-form-item>
                            <el-form-item v-if="checkboxItems === 4" label="包含">
                                <el-input v-model="selectRow.contain" :rows="4" placeholder="请填写包含费用？" style="width: 96%"
                                          type="textarea"></el-input>
                            </el-form-item>
                            <el-form-item v-if="checkboxItems === 4" label="退改">
                                <el-input v-model="selectRow.returnMsg" :rows="4" placeholder="请填写退改费用？" style="width: 96%"
                                          type="textarea"></el-input>
                            </el-form-item>
                            <el-form-item v-if="checkboxItems === 4" label="不含">
                                <el-input v-model="selectRow.excluding" :rows="4" placeholder="请填写不包含费用（非必填）？"
                                          style="width: 96%"
                                          type="textarea"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <!--条款-->
                <div class="selectTags">
                    <div class="itemTitle">
                        <i class="el-icon-circle-plus iconOptions"></i>
                        <p style="margin-left: 10px">
                            <span style="font-size: 16px">条款</span>
                            <span style="margin-left: 5px;font-size: 12px;color: rgba(86,127,0,100)">单选</span>
                            <span style="text-decoration: underline;display: inline-block;transform: scale(0.8);border-radius: 10px;color: rgb(219, 78, 26);" type=""
                                  @click="handlerOrganizationSetClick">点击新增</span>
                        </p>
                    </div>
                    <div class="right" style="height: 100px">
                        <el-radio-group v-model="clauseItems" style="display: flex;margin-left: 20px;margin-top: 5px"
                                        @change="changeRadio">
                            <el-radio v-for="(item, index) in schemeData" :key="index"
                                      :label="item.id" style="margin-bottom: 10px" @click.native.prevent="changeRadio(item.id)">{{
                                    item.schemeName
                                }}
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <!--导出模块-->
                <div class="selectTags" style="margin-top: 5px;height: 190px">
                    <div class="itemTitle">
                        <svg-icon class="iconExport bigIcon" icon-class="exportRight"></svg-icon>
                    </div>
                    <div class="right" style="border-left: none;position: relative;top: -92px">
                        <div class="Item-File"
                             style="margin-left: 20px;background-color: white;padding: 10px;border-radius: 5px;width: 93%">
                            <div>
                                <div style="position: relative">
                                    <div v-if="!text"
                                         style="background-color: rgb(245,241,241,0.9);height: 100%;width: 100%;position: absolute;color: #2b8bc6;font-weight: 700;display: flex;align-items: center;justify-content: center">
                                        <p style="text-align: center">点击下方按钮生成</p>
                                    </div>
                                    <Qr :text="text"></Qr>
                                </div>
                                <span
                                    style="display: flex;justify-content: center;margin-top: 5px;font-weight: 700">扫描查看手机版本</span>
                            </div>
                            <div>
                                <el-radio-group v-model="itemFileType" class="Export-Item-Radio-Download"
                                                @change="versionExport">
                                    <el-radio v-for="(item, index) in exportContent[0].itemFileTypeArr"
                                              :key="index" :label="item.value"
                                              style="width: 230px">
                                        <svg class="icon" height="200" p-id="5156"
                                             style="position: relative;top: 6px;" t="1728568808301" version="1.1"
                                             viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M833.841473 336.403925c-29.237791-149.914232-160.920736-263.309448-321.841473-263.309448S219.452762 186.489692 190.158527 336.403925C80.48859 365.641715 0 468.030427 0 585.038033c0 142.633006 113.395216 256.028222 255.971778 256.028222h36.57546v-73.15092h-36.57546c-102.388711 0-182.877301-80.432146-182.877301-182.877302 0-102.388711 80.432146-182.877301 182.877301-182.877301 0-142.633006 113.395216-255.971778 255.971778-255.971778 142.633006 0 256.028222 113.395216 256.028222 255.971778 102.388711 0 182.877301 80.432146 182.877301 182.877301 0 102.388711-80.432146 182.877301-182.877301 182.877302h-36.57546v73.15092h36.57546c142.633006 0 255.971778-113.395216 255.971778-256.028222 0.056444-117.007607-80.432146-219.396318-190.102083-248.634108z"
                                                p-id="5157"></path>
                                            <path
                                                d="M599.769816 782.53423l-43.856686 40.244295V511.943556c0-21.956565-18.28773-36.57546-36.575461-36.57546-21.956565 0-36.57546 18.28773-36.57546 36.57546v310.834969l-43.91313-40.244295c-14.618895-14.618895-40.244295-14.618895-54.86319 0-14.618895 14.618895-14.618895 36.57546 0 51.194356l109.726381 106.057546c3.668835 3.668835 7.337669 7.337669 10.950061 7.337669 14.618895 7.337669 29.237791 3.668835 40.244295-7.337669l106.057546-106.057546c14.618895-14.618895 14.618895-36.57546 0-51.194356-10.950061-14.618895-36.57546-14.618895-51.194356 0z"
                                                p-id="5158"></path>
                                        </svg>
                                        <span style="font-size: 12px !important;margin-left: 3px"
                                              v-html="item.name"></span>
                                        <span v-if="itemFileType === item.value" class="checked"><i
                                            class="el-icon-loading"
                                            style="position: absolute;font-weight: 700;top: 10px;left: -25px"></i></span>
                                    </el-radio>
                                </el-radio-group>
                                <mapCanvas style="display: flex;justify-content: center;margin-top: 5px;"></mapCanvas>
                            </div>
                        </div>
                        <div
                            style="width: 93%;display: flex;justify-content: center;margin-left: 20px;margin-top: 20px">
                            <el-button style="width: 50%;border-radius: 20px" type="primary"
                                       @click="submitForm">立即生成
                            </el-button>
                            <el-button style="width: 50%;border-radius: 20px"
                                       @click="collectionShow = false">取消生成
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--产品选择-->
        <budget-detail-dialog ref="budgetDetailDialog" :chenckBudget="checkBudget"
                              @chooseProduct="chooseProductSure"></budget-detail-dialog>
        <offerDetailPopup ref="offerPopup" :display-mode="true" :show-button="false" style="margin-left: -20px">
        </offerDetailPopup>
    </el-dialog>
</template>
<script>
import Api from "@/components/Api";
import mapCanvas from "@/components/MapCanvas.vue";
import Qr from "@/components/Qr.vue";
import {stockTypeMap} from '@/assets/utils/commonData'
import budgetDetailDialog from "@/views/plan/leftMoudle/dialog/budgetDetailDialog.vue";
import PlanApi from "@/components/Api/PlanApi";
import offerDetailPopup from "@/views/mechanism/components/offerDetailPopup.vue";
import PayApi from "@/components/Api/pay";
import {mapState} from "vuex";

export default {
    components: {offerDetailPopup, budgetDetailDialog, Qr, mapCanvas},
    data() {
        return {
            left: '0px',
            // 方案列表
            schemeData: [],
            // 所选中的产品
            checkProductList: [],
            // 总支付金额
            totalPayPrice: '',
            // 二维码链接信息
            text: '',
            //选择的预算单方案数据
            checkBudget: '',
            stockTypeMap,
            // 项目总价选项
            stateTotalPayPrice: [],
            // 文件下载类型
            itemFileType: -1,
            collectionShow: false,
            checkboxItems: "",
            // 项目总价选择项
            projectCheckboxItems: [],
            checkItemContent: {
                "programme": {
                    "checkAll": true,
                    "isIndeterminate": false,
                    "checkProgrammeItems": [4, 5, 6, 7, 8, 3, 2],
                    "programmeArr": [0, 1, 2, 3, 8, 4, 5, 6, 7]
                },
                "offer": {
                    "checkAll": false,
                    "isIndeterminate": false,
                    "checkOfferItems": [0, 1],
                    "offerArr": [0, 1, 2]
                },
                // 所选中的资源
                "resourceMap": [],

            },
            // 币种信息
            currencyList: [],
            // 选中的信息
            selectRow: {
                serviceProvider:null,
                contacts:null,
                // 收费金额
                feeAmount: 0,
                // 币种
                currency: "￥",
                chargingContent: ""
            },
            // 下单方式
            orderingMethodRadio: -1,
            // 条款Radio
            clauseItems: "",
            budgetFileName: '',
            // 文件下载类型排列
            exportContent: {
                // 团组报价单
                '0': {
                    itemFileTypeArr: [
                        {
                            name: `下载操作确认书<span style="color: #339900">word</span>版本`,
                            value: 2
                        },
                        {
                            name: '下载操作确认书<span style="color: #339900">pdf</span>版本',
                            value: 3
                        },
                        // {
                        //     name: '下载项目预算单<span style="color: #339900">excel</span>版本',
                        //     value: 4
                        // },
                        // {
                        //     name: '下载项目计划书<span style="color: #339900">excel</span>版本',
                        //     value: 5
                        // }
                    ]
                }
            },
        }
    },
    mounted() {
        this.loadCurrency()
        this.getScheme()
        this.getMyPlanBudgetName(this.budgetMainId)
    },
    computed: {
        ...mapState(['budgetMainId']),
        ...mapState(['planId']),
        ...mapState(['userInfor'])
    },
    methods: {
        // 生成收款订单以及二维码
        submitForm() {
            this.selectRow.planId = this.planId;
            this.selectRow.budgetMainId = this.budgetMainId;
            this.selectRow.collectionType = this.checkboxItems
            if (this.checkboxItems === 1 || this.checkboxItems === 2) {
                this.checkProductList = []
                this.checkBudget.planDayList.forEach(element => {
                    element.budgetDetails.forEach(e => {
                        if (this.checkboxItems === 1 || (this.checkboxItems === 2 && this.projectCheckboxItems.indexOf(e.state) !== -1)) {
                            e.details.forEach(ee => {
                                this.checkProductList.push(ee.id)
                            })
                        }
                    })
                });
            } else if (this.checkboxItems === 4) {
                this.checkProductList = []
            }
            this.selectRow.collectionLinkData = JSON.stringify(this.checkProductList)
            this.selectRow.isAutoOrder = this.selectRow.payOrder
            this.selectRow.id = null
            console.log("jdhjfhjdhfjdhf", this.selectRow)
            new PayApi("pay").addCollection(this.selectRow).then(res => {
                if (res.status === 200) {
                    // this.text = process.env["VUE_APP_COLLECTION_H5_SERVE"] + `?type=2&collectionId=${res.data.collectionId}&ciphertext=${res.data.ciphertext}&programmeId=${this.clauseItems}`
                    this.text = process.env["VUE_APP_INVOICE_H5_SERVE"] + `?type=2&collectionId=${res.data.collectionId}&ciphertext=${res.data.ciphertext}`
                    this.fullscreenLoading = false
                    this.selectRow.id = res.data.collectionId
                    console.log("小程序链接", this.text)
                    this.$message.success('二维码已生成!')
                } else {
                    this.$message.error(res.statusText)
                }
            })
        },
        changeRadio(e) {
            e === this.clauseItems ? this.clauseItems = 0 : this.clauseItems = e
            let _find = this.schemeData.find(x => x.id == e)
            if (_find && this.clauseItems > 0) {
                this.$nextTick(() => {
                    this.$refs.offerPopup.init(_find.htmlContentStr)
                })
                let doc = document.getElementsByClassName("collectionNewDialog")[0]
                doc.style.left = "350px !important"
                this.left = "350px"
            } else {
                this.$refs.offerPopup.close()
            }
            this.selectRow.schemeId = e
        },
        getScheme() {
            new PlanApi("plan").queryByCompanyId(1).then(res => {
                if (res.status === 200) {
                    this.schemeData = res.data
                }
            })
        },
        handlerOrganizationSetClick(e) {
            this.$router.push({
                name: 'organization',
                query: {
                    currentComponent: 'organizationSet', //需要切换到那个组件
                    organizationIsFun: true, //是否调用事件
                    btns: '文字说明维护',
                    btns1: '确认单说明'
                }
            });
        },
        chooseProduct() {
            this.$refs.budgetDetailDialog.openDialog(2)
            this.checkboxItems = 3
        },
        // 产品选择所返回的内容
        chooseProductSure(e) {
            console.log("chooseProductSure", e)
            let price = 0
            this.checkProductList = []
            e.forEach(ee => {
                if (ee.checkFlag) {
                    this.checkProductList.push(ee.id)
                    price = price + (ee.ratio * ee.stockNumber * ee.rate)
                }
            })
            this.selectRow.feeAmount = price
            this.selectRow.oldfeeAmout = this.selectRow.feeAmount
        },
        currencyChange(e) {
            // alert(e)
            this.$set(this.selectRow, "currency", e)
        },
        getMyPlanBudgetName() {
            new PlanApi("plan").getPlanBudgetName(this.budgetMainId).then(res => {
                if (res.status === 200) {
                    this.budgetFileName = res.data
                }
            })
        },
        // 导出版本
        versionExport(e) {
            // this.$refs.offerPopup.close()
            let fileSuffix = '.pdf'
            if (this.itemFileType === 0 || this.itemFileType === 2) {
                fileSuffix = ".docx"
            }
            if (this.itemFileType === 4 || this.itemFileType === 5) {
                fileSuffix = ".xlsx"
            }
            let fileName = "团组确认书";
            if (this.itemFileType === 4) {
                fileName = "项目计划书"
            }
            if (this.itemFileType === 5) {
                fileName = "项目预算单"
            }
            fileName = this.budgetFileName.replace("报价单", "确认书") + " " + fileName;
            this.exportDocument(fileName, fileSuffix)
        },
        exportDocument(fileName, fileSuffix) {
            new PlanApi("plan").exportPlanToWord(this.budgetMainId, this.clauseItems, fileName, this.itemFileType, this.checkItemContent, fileSuffix, (e) => {
                if (e) {
                    this.itemFileType = -1
                }
            }).then(res => {
                this.budgetFileName = ""
            }).catch(() => {
                this.$message.error("系统异常")
                // loading.close()
            })
        },
        // 选项变更
        checkboxItemsChange(e) {
            this.selectRow.feeAmount = 0
            if (e === 4) {
                this.orderingMethodRadio = -1
            } else {
                this.orderingMethodRadio = 1
            }
            if (e === 1) {
                this.selectRow.feeAmount = this.totalPayPrice.toFixed(2)
                let findCurrency = this.currencyList.find(x => x.code === "￥")
                if (findCurrency) {
                    this.selectRow.currency = findCurrency.code
                }
            }
            // 单人价格
            if (e === -1) {
                this.selectRow.feeAmount = (this.totalPayPrice / this.checkBudget.useNumber).toFixed(2)
                let findCurrency = this.currencyList.find(x => x.code === "￥")
                if (findCurrency) {
                    this.selectRow.currency = findCurrency.code
                }
            }
            // 项目总价
            if (e === 2) {
                this.selectRow.feeAmount = 0
                // this.selectRow.currency = ""
                this.projectCheckboxItems = []
            }
        },
        projectCheckboxItemsChange(e) {
            let totalPrice = 0
            console.log("projectCheckboxItemsChange", this.stateTotalPayPrice, this.projectCheckboxItems)
            this.stateTotalPayPrice.forEach(item => {
                for (let i = 0; i < this.projectCheckboxItems.length; i++) {
                    let projectCheckbox = this.projectCheckboxItems[i]
                    if (projectCheckbox === item.state) {
                        totalPrice = totalPrice + item.price
                    }
                }
            })
            this.selectRow.feeAmount = totalPrice.toFixed(2)
            let findCurrency = this.currencyList.find(x => x.code === "￥")
            if (findCurrency) {
                this.selectRow.currency = findCurrency.code
            }
        },
        init(data) {
            console.log("init", data)
            this.totalPayPrice = 0
            this.collectionShow = true
            this.checkBudget = data
            this.stateTotalPayPrice = []
            // 设定接口请求数据
            this.selectRow.id = null
            this.selectRow.feeAmount = null
            this.selectRow.serviceProvider = this.userInfor.companyName || null
            this.selectRow.contacts = this.userInfor.name || null
            this.text = ''
            for (let i = 0; i < data.planDayList.length; i++) {
                let element = data.planDayList[i]
                if (!element.budgetDetails) {
                    continue
                }
                element.budgetDetails.forEach(e => {
                    let index = this.stateTotalPayPrice.findIndex(ee => ee.state === e.state)
                    if (index === -1) {
                        this.stateTotalPayPrice.push({
                            state: e.state,
                            price: 0,
                        })
                        index = this.stateTotalPayPrice.length - 1
                    }
                    e.details.forEach(ee => {
                        this.totalPayPrice = Number(this.totalPayPrice) + (ee.ratio * ee.stockNumber * ee.rate)
                        this.stateTotalPayPrice[index].price = this.stateTotalPayPrice[index].price + (ee.ratio * ee.stockNumber * ee.rate)
                    })
                })
            }
        },
        // 加载币种信息
        loadCurrency() {
            new Api('resource').currencySearch({code: ""}).then(res => {
                if (res.status === 200) {
                    this.currencyList = res.data
                    this.currencyList.forEach(item => {
                        item.currencyOption = item.code + ' ' + item.name + ' 收款汇率：' + (!item.payeeRate ? '暂无信息' : item.payeeRate)
                    })
                }
            })
        }
    }
}
</script>
<style scoped>
.collectionNewDialog {
}
</style>
<style lang="scss" scoped>
/deep/ .el-form-item__label {
    padding-bottom: 0;
}

/deep/ .el-form-item {
    margin-bottom: 5px;
}

.headerTitle {
    text-align: center;
    font-size: 16px;
    font-weight: 700;
}

.bodyContent {
    width: 100%;
    min-height: 300px;
    background-color: rgba(247, 247, 247, 100);
    margin-top: 5px;
    padding: 15px;

    > p {
        font-size: 14px;
        font-weight: 700;
    }

    .selectTags {
        display: flex;
        flex-direction: column;
        margin-top: 10px;

        .right {
            border-left: 1px solid rgba(200, 63, 0, 100);
            margin-left: 9px;
            margin-top: 8px;

            .Item-File {
                display: flex;
                margin-top: 10px;
            }
        }

        .itemTitle {
            display: flex;
            font-size: 14px;
        }
    }
}

/deep/ .Export-Item-Radio-Download {
    display: flex;
    flex-direction: column;
    position: relative;
    top: -5px;
    //height: 100px;
    //overflow-y: scroll;

    .is-checked {
    }

    .el-radio {
        display: flex;
        color: black;
        width: 230px;
        margin-right: 0;
        margin-top: 5px;
        padding-left: 5px;
        line-height: 3;
        margin-bottom: 1px;
        margin-left: 20px;

        //background-color: rgba(219, 78, 26, 0.4);
        //border: rgba(219, 78, 26, 0.4) 1px solid;
        .el-radio__input {
            display: none;
        }

        .el-radio__label {
            //color: black;
            opacity: 1;
            width: 210px;
            padding-left: 15px;
            line-height: 1.6;
            font-size: 14px !important;
            box-shadow: 0px 3px 10px rgba(221, 221, 221, 0.9);
            border-radius: 25px;

            .el-icon-upload:before {
                font-size: 20px;
                padding-right: 10px;
                position: relative;
                top: 1px;
            }
        }

        .checked {
            position: absolute;
            top: 0;
            right: 0;
            width: 12px;
            height: 12px;
            //background-color: rgba(219, 78, 26, 0.7);
            //border-radius: 0px 10px 0px 0px;
        }
    }
}

.iconOptions {
    color: rgba(200, 63, 0, 100);
    font-size: 20px;
}

.bigIcon {
    height: 25px;
    width: 25px;
    color: #DB4E1A;
}
</style>